export const COOKIE_CONSENT_KEY = 'sosvor-cookie-consent'

export function readCookieConsent() {
  try {
    const value = localStorage.getItem(COOKIE_CONSENT_KEY)
    if (value === 'accepted' || value === 'rejected') return value
  } catch {
    /* ignore */
  }
  return null
}

export function writeCookieConsent(value) {
  try {
    localStorage.setItem(COOKIE_CONSENT_KEY, value)
  } catch {
    /* ignore */
  }
}

export function hasCookieConsentChoice() {
  return readCookieConsent() !== null
}
